import _ from 'underscore';
import Promise from 'bluebird';
import { servletSave } from './helpers';

export default class ScheduleTokenDAO {
  constructor(urls) {
    this.SCHEDULE_TOKENS_URL = urls.SCHEDULE_TOKENS_URL;
  }

  create(pairs) {
    if (!_.isArray(pairs)) {
      return Promise.reject(new Error('Must be array of objects'));
    }

    if (pairs.length === 0) {
      return Promise.reject(new Error('No pairs specified!'));
    }

    if (!_.all(pairs, ({ schoolId, league }) => typeof schoolId === 'string' && typeof league === 'string')) {
      return Promise.reject(new Error('All pairs must have schoolId and league'));
    }

    if (!_.all(pairs, ({ league }) => _.contains([ 'BOYS_HIGH_SCHOOL', 'GIRLS_HIGH_SCHOOL' ], league))) {
      return Promise.reject(new Error('All leagues must be one of BOYS_HIGH_SCHOOL or GIRLS_HIGH_SCHOOL'));
    }

    return servletSave(this.SCHEDULE_TOKENS_URL, pairs);
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dao/ScheduleTokenDAO.js